"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _components = _interopRequireWildcard(require("../components"));
var Components = _components;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
class DetailFactory extends _react.default.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "renderGrid", fields => {
      const entityName = this.props.entity.plural;
      const editPermission = this.props.auth.me.data.FlatPermissions.filter(permission => permission.Value === `control.${entityName}/edit`);
      const developerPermission = this.props.auth.me.data.FlatPermissions.filter(permission => permission.Value === `*`);
      let i = 0;
      if (fields.rows) {
        let fi = fields.rows;
        if (editPermission.length === 0 && developerPermission.length === 0) {
          fi = fields.rows.filter(row => row.type !== "Join" && row.type !== "RelationPicture");
          return /*#__PURE__*/_react.default.createElement("div", {
            className: fields.size || "col"
          }, fi.map(field => /*#__PURE__*/_react.default.createElement("div", {
            className: "row",
            key: `row-${i++}`
          }, this.renderGrid(field))));
        } else {
          return /*#__PURE__*/_react.default.createElement("div", {
            className: fields.size || "col"
          }, fi.map(field => /*#__PURE__*/_react.default.createElement("div", {
            className: "row",
            key: `row-${i++}`
          }, this.renderGrid(field))));
        }
      }
      if (fields.fields) {
        return /*#__PURE__*/_react.default.createElement("div", {
          className: fields.size || "col"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "row"
        }, fields.fields.map(field => this.renderGrid(field))));
      }
      return /*#__PURE__*/_react.default.createElement("div", {
        className: fields.size || "col"
      }, this.renderField(fields));
    });
    _defineProperty(this, "renderField", field => {
      const {
        schema,
        onChange,
        [this.props.entity.singular]: store
      } = this.props;
      const Component = Components[schema[field.key].type];
      if (!Component) return false;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: `form-group`,
        key: field.key
      }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("label", {
        htmlFor: field.key,
        className: "text-muted text-uppercase"
      }, /*#__PURE__*/_react.default.createElement("small", null, schema[field.key].displayName)), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(Component, {
        key: field.key,
        value: store.fetched && store.data[field.key],
        fetched: store.fetched,
        fetching: store.fetching,
        format: schema[field.key].format,
        schema: schema[field.key],
        row: store.data,
        edit: true
      }))));
    });
  }
  render() {
    const {
      schema,
      fields,
      entity,
      singular,
      [this.props.entity.singular]: store,
      ...rest
    } = this.props;
    if (!store) console.error(`No data provided for ${entity.singular}`);
    if (!store.fetched) return /*#__PURE__*/_react.default.createElement(_components.Spinner, null);
    if (store.data) {
      if (store.data.Id !== singular) {
        return /*#__PURE__*/_react.default.createElement(_components.Spinner, null);
      }
    }
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "row"
    }, this.renderGrid(fields));
  }
}
var _default = exports.default = DetailFactory;
module.exports = exports.default;